import availabilitiesCoaching from './availabilitiesCoaching'
import availabilitiesTherapy from './availabilitiesTherapy'
import genders from './gender'
import lgbtqia from './lgbtqia'
import meetingSettingCoaching from './meetingSettingCoaching'
import meetingSettingTherapy from './meetingSettingTherapy'
import raceEthnicityCoaching from './raceEthnicityCoaching'
import raceEthnicityTherapy from './raceEthnicityTherapy'
import religion from './religion'
import { MemberPreferenceFeatureFlagValues, PreferenceMetadataConfig } from './types'
import veterans from './veteran'
import { S4C_PROGRAM_OPTION_FLOW } from '../constants'

// The active set of preferences we currently surface across all MP workflows
export const activeMemberPreferenceListOptions = [
  genders,
  availabilitiesCoaching,
  availabilitiesTherapy,
  raceEthnicityCoaching,
  raceEthnicityTherapy,
  lgbtqia,
  religion,
  veterans,
  meetingSettingTherapy,
  meetingSettingCoaching,
]

const ousMemberPreferenceListOptionsV1 = [meetingSettingTherapy]

const ousMemberPreferenceListOptionsV2 = [genders, raceEthnicityTherapy, lgbtqia, veterans, meetingSettingTherapy]

export const getAvailableMemberPreferenceListOptions = ({
  isUserInternational,
  areExpandedGlobalPreferencesEnabled,
}: {
  isUserInternational: boolean
  areExpandedGlobalPreferencesEnabled: boolean
}) => {
  if (!isUserInternational) {
    return activeMemberPreferenceListOptions
  }

  return areExpandedGlobalPreferencesEnabled ? ousMemberPreferenceListOptionsV2 : ousMemberPreferenceListOptionsV1
}

export const getIsMemberPreferenceAvailableForCountry = ({
  preferenceMetadataConfig,
  userCountryIsoCode,
  searchForCareProgramOptionFlow,
  featureFlags = {},
}: {
  preferenceMetadataConfig: PreferenceMetadataConfig
  userCountryIsoCode?: string
  searchForCareProgramOptionFlow: S4C_PROGRAM_OPTION_FLOW
  featureFlags?: MemberPreferenceFeatureFlagValues
}) => {
  if (userCountryIsoCode == undefined) return false

  // Ensure country ISO code is supported and valid
  const countryPreferenceConfig = preferenceMetadataConfig.countryConfig[userCountryIsoCode]
  if (countryPreferenceConfig == undefined) return false

  // Ensure preference is available for current search for care flow
  const isAvailableForProgramOptionFlow =
    countryPreferenceConfig.programOptionFlows.includes(searchForCareProgramOptionFlow)
  if (isAvailableForProgramOptionFlow === false) return false

  // Ensure any required feature flags are enabled for the current country
  const { requiredFeatureFlag } = countryPreferenceConfig
  if (requiredFeatureFlag == undefined) return true

  return featureFlags[requiredFeatureFlag] === true
}
